<template>
  <div>
    <v-layout wrap class="mb-2">
      <v-flex xs9>
        <h3 class="headline mt-0 mb-0">
          <img src="/static/img/logo-J&T.png" alt style="max-height: 80px" />
        </h3>
      </v-flex>
    </v-layout>
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div v-else>
      <v-stepper v-model="step" vertical class="elevation-0">
        <v-stepper-step step="1" :complete="step > 1">
          {{ $t('register_jt') }}
        </v-stepper-step>
        <v-stepper-content step="1">
          <div>{{ $t('connect_jt_service_for_more') }}</div>
          <v-btn depressed color="primary" target="_blank" @click="generateJandtShop">
            {{ $t('create_shop_with_jt') }}</v-btn
          >

          <v-btn flat @click="step = 2">
            {{ $t('already_have_an_account') }}
          </v-btn>
          <div>
            <a href="https://blog.zwiz.ai/zwizai-x-jtexpress/" target="_blank">{{
              $t('how_to_use_jt')
            }}</a>
          </div>
        </v-stepper-content>
        <v-stepper-step step="2" :complete="step > 2">
          {{ $t('connect_zwiz_with_jt') }}
        </v-stepper-step>
        <v-stepper-content step="2">
          <div class="pa-2" style="position: relative">
            <div class="mb-2">
              <v-btn color="primary" outline @click="dialog = true">
                {{ $t('registration_process') }}</v-btn
              >
            </div>

            <template>
              <div class="caption">Shop ID</div>
              <div v-if="!loading" class="primary--text mb-2">
                {{ setting.shop_id ? setting.shop_id : '-' }}
              </div>
              <div class="caption">Shop Name</div>
              <div v-if="!loading" class="primary--text mb-2">
                {{ setting.shop_name ? setting.shop_name : '-' }}
              </div>
              <div v-if="showCancel" class="mb-2">
                <div>
                  {{ $t('enable_disable_jt') }}
                </div>
                <div>
                  <toggle-button
                    class="mt-2"
                    :value="setting.is_active"
                    :sync="true"
                    :color="$vuetify.theme.success"
                    :labels="{ checked: 'ON', unchecked: 'OFF' }"
                    style="display: inline-block"
                    @change="toggleStatus"
                  />
                </div>
              </div>
              <v-dialog ref="dialog" v-model="dialog" width="700px">
                <v-card>
                  <v-card-text>
                    <v-layout wrap class="mb-4">
                      <v-flex xs9 style="align-self: center">
                        <h3>{{ $t('vip_registration_process') }}</h3>
                      </v-flex>
                      <v-flex xs3 class="text-xs-right">
                        <v-btn fab small flat @click="dialog = false">
                          <v-icon>close</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <ul>
                      <li class="mb-2">
                        {{ $t('vip_registration_process_1') }}
                      </li>
                      <li class="mb-2">
                        {{ $t('vip_registration_process_2') }}
                      </li>
                      <li class="mb-2">
                        {{ $t('vip_registration_process_3') }}
                        <div class="ml-2">- {{ $t('vip_registration_process_31') }}</div>
                        <div class="ml-2">-{{ $t('vip_registration_process_32') }}</div>
                        <div class="ml-2">-{{ $t('vip_registration_process_33') }}</div>
                      </li>
                      <li class="mb-2">
                        {{ $t('vip_registration_process_4') }}
                      </li>
                      <li class="mb-2">
                        {{ $t('vip_registration_process_5') }}
                      </li>

                      <li class="mb-2">
                        {{ $t('vip_registration_process_6') }}
                      </li>
                      <li class="mb-2">
                        {{ $t('vip_registration_process_7') }}
                      </li>
                      <li class="mb-2">
                        {{ $t('vip_registration_process_8') }}
                      </li>
                      <li class="mb-4 primary--text">
                        {{ $t('vip_remark') }}
                      </li>
                      <li class="text-xs-center">
                        <v-img
                          :src="`/static/img/assets/payment/เอกสารการสมัครเป็น ลูกค้า VIP J_T.jpg`"
                        />
                        <div class="mt-2 mb-2">
                          <small
                            >รายละเอียด เอกสารที่ทางลูกค้าของแพลตฟอร์มต้องใช้สมัครเป็น VIP
                            ของทางหน้าสาขา J&T</small
                          >
                        </div>
                        <v-btn color="primary" outline @click="openForm">
                          {{ $t('fill_in_the_form') }}</v-btn
                        >
                      </li>
                    </ul>
                  </v-card-text>
                </v-card>
              </v-dialog>
              <template v-if="JandTToken">
                <div class="caption">Token</div>
                <div class="primary--text">
                  {{ JandTToken }}
                </div>
              </template>
            </template>
          </div>
        </v-stepper-content>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ToggleButton } from 'vue-js-toggle-button'
import { handleApiError } from '@/api/util'
import jAndTApi from '@/api/j-and-t.js'
export default {
  components: {
    ToggleButton
  },
  data() {
    return {
      dialog: false,
      loading: false,
      JandTToken: null,
      setting: {
        is_active: false,
        store_name: null,
        api_key: null,
        api_secret: null,
        endpoint_url: 'https://api.JandT.com/api.aspx',
        api_version: '3'
      },
      showCancel: true,
      step: 1
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  async mounted() {
    this.getJandtConfig()
  },
  methods: {
    openForm() {
      window.open('https://forms.gle/MydKom9nN8yfuVGT6', '_blank')
    },
    async getJandtConfig() {
      const vm = this
      const data = {
        pageid: vm.selectedBot.pageid
      }
      try {
        let response = await jAndTApi.getConfig(data)

        if (response.status == 200 && response.data.message == 'SUCCESS') {
          vm.setting = response.data.result
          if (vm.setting.shop_id) {
            vm.step = 2
          }
          vm.setting.is_active = true
        } else {
          vm.setting.is_active = false
        }
      } catch (error) {
        handleApiError(error)
      }
    },
    async putJandtConfig() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const config = {
          pageid: vm.selectedBot.pageid,
          data: { is_active: vm.setting.is_active }
        }
        let response = await jAndTApi.putConfig(config)

        vm.$store.dispatch('loading')
        if (response.status == 200 && response.data.message == 'SUCCESS') {
          vm.$swal({
            title: vm.$t('Save successful'),
            type: 'success',
            confirmButtonText: vm.$t('Confirm'),
            reverseButtons: true
          })
        } else {
          vm.setting.is_active = !vm.setting.is_active
        }
      } catch (error) {
        handleApiError(error)
      }
    },
    async toggleStatus() {
      const vm = this
      vm.setting.is_active = !vm.setting.is_active
      vm.putJandtConfig(vm.setting)
    },
    async generateJandtShop() {
      const vm = this
      try {
        const config = {
          pageid: vm.selectedBot.pageid
        }
        let response = await jAndTApi.postGenerateShop(config)
        if (response.status == 200 && response.result) {
          vm.$swal.fire({
            title: vm.$t('Create shop with J&T successful'),
            type: 'success',
            confirmButtonText: vm.$t('Confirm'),
            reverseButtons: true
          })
          vm.JandTToken = response.result.general_token
        }
        if (response.result) {
          vm.step = 2
        }
      } catch (error) {
        handleApiError(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/JandtManage.vue